export const MAX_UPDATE_AGE_SECONDS = 60
